import { Component } from '@angular/core';
import { PermaBaseComponent } from './perma-base.component';
import { RBCheck } from '@ldw/roesberg';

@Component({
    selector: 'ldw-pltsearch',
    templateUrl: './component.html',
    styleUrls: ['./component.css'],
    standalone: false
})
export class PltTreeSearchComponent extends PermaBaseComponent {
  protected process() {
    if (RBCheck.isNullOrEmpty(this.node)) {
      // no node given, so go to root
      this.routerService.navigateToBasic(this.webDokuId, '');
      return;
    }
    // go document navigation and search for node
    this.routerService.navigateToBasicTreeSearch(this.webDokuId, this.node);
  }
}
